module.exports = __webpack_public_path__ + "img/hepato_gastro.16441397.png";